module.exports = __webpack_public_path__ + "static/img/summer_jianjiePic.c5782844.png";